import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { SocialPlatform, SocialPublication } from '@/api/social'
import { TelegramCaption } from '@/components/admin/social/TelegramCaption'
import { safeHttpUrl } from '@/utils/telegramHtml'

/**
 * Рендер поста одной платформы. Telegram — обложка и подпись; VK — текст и
 * пометка, что картинку VK подтянет превью ссылки на новость.
 */
export function SocialPostPreview({ platform, publication }: { platform: SocialPlatform; publication: SocialPublication }) {
  const { t } = useTranslation()

  const emptyText = (
    <Typography variant="body2" color="text.secondary">
      {t('admin.social.noText')}
    </Typography>
  )

  if (platform === 'telegram') {
    const coverUrl = safeHttpUrl(publication.cover_url)

    return (
      <Box sx={{ minWidth: 0 }}>
        {coverUrl ? (
          <Box
            component="img"
            src={coverUrl}
            alt={t('admin.social.coverAlt')}
            sx={{ display: 'block', width: '100%', maxHeight: 280, objectFit: 'cover', borderRadius: 1, mb: 1 }}
          />
        ) : (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
            {t('admin.social.noCover')}
          </Typography>
        )}
        {publication.text_telegram ? <TelegramCaption html={publication.text_telegram} /> : emptyText}
      </Box>
    )
  }

  return (
    <Box sx={{ minWidth: 0 }}>
      {publication.text_vk ? (
        <Typography component="div" variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
          {publication.text_vk}
        </Typography>
      ) : (
        emptyText
      )}
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        {t('admin.social.vkPreviewNote')}
      </Typography>
    </Box>
  )
}
